import {observer} from "mobx-react";
import {useContext, useState} from "react";
import {Button} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import {MyRecordingsStoreContext, RecordingsStoreContext} from "../stores/RecordingsStore";
import {Header} from "../components/sections/Header";
import {Frame} from "../components/common/Frame";
import {Sessions} from "../components/pages/sessions/Sessions";
import {UploadSessionDialog} from "../components/recordings/UploadSessionDialog";
import {AppRoutes} from "../AppRoutes";
import {useNavigate} from "react-router";

export const MySessions = observer(() => {
  const store = useContext(MyRecordingsStoreContext)!;
  const navigate = useNavigate();
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  if (!store) return null;

  return <Frame>
    <Header
      pathCrumbs={[
        [AppRoutes.index, 'Home'],
        [undefined, 'My Sessions'],
      ]}
      action={
        <Button
          variant="contained"
          startIcon={<UploadIcon/>}
          onClick={() => setUploadDialogOpen(true)}
        >
          Upload Session
        </Button>
      }
    />
    <Frame contentWidth>
      <RecordingsStoreContext.Provider value={store}>
        <Sessions onSelect={(recording) => {
          if (!recording.id) {
            return;
          }
          navigate(AppRoutes.mySessionPath(recording.id));
        }}/>
      </RecordingsStoreContext.Provider>
    </Frame>

    <UploadSessionDialog
      open={uploadDialogOpen}
      onClose={() => setUploadDialogOpen(false)}
    />
  </Frame>;
});
